import { Product } from "../Support/Account/AddOnsSupport/types";
import ProductCard from "./ProductCard";

interface Step1Props {
  children?: React.ReactNode;
  onSelectPlan: (product: Product) => void;
  products: Product[];
  recommendedProductId?: number;
  currentProductId?: number;
}

const Step1: React.FC<Step1Props> = ({
  children,
  onSelectPlan,
  products,
  recommendedProductId,
  currentProductId,
}) => {
  const indexOfCurrent = currentProductId
    ? products.findIndex((product) => product.details.productId === currentProductId)
    : Infinity;
  return (
    <div className="tw-w-full tw-relative">
      <div className="tw-flex tw-gap-[16px]">
        {products.map((product, index) => (
          <ProductCard
            key={product.id}
            isRecommended={product.details.productId === recommendedProductId}
            isCurrent={product.details.productId === currentProductId}
            isUpgrade={index > indexOfCurrent}
            product={product}
            onClick={() => onSelectPlan(product)}
          />
        ))}
      </div>
      {children}
    </div>
  );
};

export default Step1;
